<template>

   <div v-if="goog_id!='a'">
      <!-- 
      <h1>Type class to add notify</h1>

      <div class="input-group col-md-4 mb-4">
         <input v-on:keyup.enter="onEnter()" v-model="classNumber" class="form-control py-2" type="search" value=""
            id="example-search-input" placeholder="Enter Class Number">
         <span class="input-group-append">
            <button class="btn btn-outline-secondary" type="button">
               <i class="fa fa-search"></i>
            </button>
         </span>
      </div> -->


      <button type="button" class="btn btn-primary mb-3 mt-3" data-toggle="modal" data-target="#exampleModal"
         data-whatever="@mdo">Add class</button>




      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Add information about the class</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <form>

                     <div class="form-group">
                        <label for="recipient-name" class="col-form-label">Phone Number</label>
                        <input type="text" class="form-control" v-model="phone" id="recipient-name">
                     </div>
                     <div class="form-group">
                        <label for="recipient-name" class="col-form-label">Class Number</label>
                        <input type="text" v-model="classNumber" class="form-control" id="recipient-name">
                     </div>

                  </form>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" @click="onEnter" data-toggle="modal"
                     data-target="#exampleModal" data-whatever="@mdo">Add</button>
               </div>
            </div>
         </div>
      </div>


      <!-- <div class="input-group mb-3 mt-3">

         <input v-on:keyup.enter="onEnter" class="form-control" id="exampleInputEmail1"
            placeholder="Enter Professor Name">
      </div> -->






      <table class="table table-bordered mb-10">
         <thead>
            <tr>
               <th scope="col">#</th>
               <th scope="col">Instructor</th>
               <th scope="col">Class</th>
               <th scope="col">Available seats</th>
               <th scope="col">Enrolled</th>
               <th scope="col">Capacity</th>
               <th scope="col">Waitlist</th>
               <th scope="col">Notification</th>
            </tr>
         </thead>
         <tbody>

               <div v-if="loaded"class="spinner-grow" role="status">
                     <span class="sr-only">Loading...</span>
                   </div>



            <tr v-for="it in classes">
               <th scope="row">{{it.class_nbr}}</th>
               <td>{{it.Instructor}}</td>
               <td>{{ it.class_title}}</td>
               <td>{{it.available_seats}}</td>
               <td>{{it.enrolled}}</td>
               <td>{{it.enrollment_capacity}}</td>
               <td>{{it.wait_list_total}}</td>

               <td>

                  <div class="form-check form-check-inline ml-4">

                        <input type="checkbox" class="form-check-input" id="exampleCheck1" checked="checked">


                  </div>


               </td>
            </tr>

         </tbody>
      </table>

   </div>

   <div v-else>

      <div class="alert alert-warning mt-3" role="alert">
         You need to sign in to access this page
      </div>
   </div>
</template>


<script>
   import axios from 'axios'
   import { mapState, mapMutations, mapActions } from 'vuex'

   export default {

      data() {
         return {
            filtering: {},
            classes: [],
            classNumber: 22663,
            checked: {},
            phone: "",
            loaded: true,
         }
      },

      computed: {
         ...mapState([
            'goog_id',
         ]),
      },
      watch: {
         goog_id() {
            console.log("goog_id was changed")

            this.loadNotification();
            // this.getMyData()
            // console.log(this.$store.state.myDataDict)
         }

      },




      async created() {


         // console.log(this.$store.state.goog_id)

         this.loadNotification();








         // var response = {}
         // response.data = {
         //    Instructor: "Nawab,F.",
         //    Room: "J Bask Aud 101",
         //    Times: "MWF 02:40PM-03:45PM",
         //    Dates: "09/26/19 - 12/06/19",
         //    class_title: "CSE 130 - 01   Principles of Computer Systems Design",
         //    class_nbr: "22663",
         //    available_seats: "0",
         //    enrollment_capacity: "195",
         //    enrolled: "195",
         //    wait_list_capacity: "999",
         //    wait_list_total: "79"
         // }

         // this.classes.push(response.data)




      },



      methods: {

         async loadNotification() {



            const response = await axios({
               method: 'POST',
               url: 'https://us-central1-faceclass-221a7.cloudfunctions.net/nodecruz/getallnotifications',
               data: {
                  goog_id: this.$store.state.goog_id
               }
            })

            // console.log(response.data)

            this.loaded = false

            this.classes = response.data
         },

         async onEnter() {

            this.filtering['class_nbr'] = this.classNumber

            this.filtering['goog_id'] = this.$store.state.goog_id
            this.filtering['phone'] = this.phone


            console.log(this.filtering)




            const response = await axios({
               method: 'POST',
               url: 'https://us-central1-faceclass-221a7.cloudfunctions.net/nodecruz/addnotify',
               data: this.filtering
            })


            console.log(response.data)

            this.classes.push(response.data)

         }

      }


   }





</script>